export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11940.5435b0b6.jpg";